import { SearchInput } from './components/SearchInput';
import { SearchPageContainer } from './components/SearchPageContainer';
import { UseSearchProvider } from './useSearchPage';

import type { UseSearchProviderProps } from './useSearchPage';
import type { RichContentProps } from '../../components/RichContent';
import type { SearchItemComponentType } from '../../components/Search';
import type { TopLevelNormalize } from '@insify/ui-utils';

export type SearchCopy = {
  richContent?: RichContentProps;
  footer?: React.ReactNode;
  noResult: JSX.Element;
  translations: {
    showMore: string;
    forward?: string;
    searchLabel?: string;
    searchTooltip?: string;
    searchPlaceholder?: string;
    continueWithoutValue?: string;
    privacyPolicy?: string;
  };
};

export type SearchPageProps<SearchType> = TopLevelNormalize<
  Omit<UseSearchProviderProps<SearchType>, 'children'> & SearchCopy
> & {
  searchResultListClassName?: string;
  Item: SearchItemComponentType<SearchType>;
  searchActions?: React.ReactNode;
};

export const SearchPage = <SearchType,>({
  richContent,
  translations,
  noResult,
  footer,
  searchResultListClassName,
  Item,
  searchActions,
  ...providerProps
}: SearchPageProps<SearchType>) => {
  return (
    <UseSearchProvider {...providerProps}>
      <SearchPageContainer translations={translations} richContent={richContent} footer={footer}>
        <SearchInput
          translations={translations}
          noResult={noResult}
          searchResultListClassName={searchResultListClassName}
          Item={Item}
          searchActions={searchActions}
        />
      </SearchPageContainer>
    </UseSearchProvider>
  );
};
